import { useDotLegalBreadCrumbs } from "@dotlegal/dotlegal-ui-components";
import CasePage, { CasePageProps } from "../../core/cases/CasePage";
import { CaseSummarization } from "../../core/cases/CaseSummarizationPage";

function Watches(props: CasePageProps) {
    useDotLegalBreadCrumbs([{ name: "Watches" }]);
    return <CasePage {...props} caseSummarization={CaseSummarization.Watches} />;
}

export default Watches;
